/**
 * @fileoverview Project-related route definitions.
 */

import { lazy } from 'react';
import type { RouteObject } from 'react-router';
import { createRoutes } from '../utils/routeHelpers';
import DynamicIdPage from '../components/DynamicIdPage';

const ProjectsHubPage = lazy(() => import('../../features/projects/pages/ProjectsHubPage'));

export const projectsRoutes: RouteObject[] = createRoutes([
  { path: 'projects', Component: ProjectsHubPage },
  { path: ':id', Component: DynamicIdPage },
]);
